export default __webpack_public_path__ + "./images/bh.73f2237a.png";